import { useRouter } from 'next/router';
import { translations } from './translations';
import { useLocalStorage } from '../hooks/useLocalStorage';

export function useTranslations() {
    const router = useRouter();
    const { locale = 'de' } = router;
    const [language, setLanguage, setNextLocaleCookie] = useLocalStorage('i18n_language', 'de');

    // Flache Key-Übersetzung
    const t = (key) => {
        const value = translations[locale][key];
        return value !== undefined ? value : key;
    };

    const tHtml = (key) => {
        const translation = t(key);
        return { __html: translation };
    };

    const changeLanguage = (newLocale) => {
        if (newLocale === locale) return;

        setNextLocaleCookie(newLocale);

        // Domain-basiertes i18n: kein /de oder /en in der URL
        let path = router.asPath || '/';
        // Locale-Prefix entfernen falls vorhanden (alte Links / Cookies)
        path = path.replace(/^\/(de|en)(?=\/|$)/, '') || '/';
        if (!path.startsWith('/')) path = `/${path}`;

        const isLocalDev =
            typeof window !== 'undefined' &&
            (process.env.NODE_ENV === 'development' ||
                window.location.hostname === 'localhost' ||
                window.location.hostname === '127.0.0.1');

        if (isLocalDev) {
            router.push(path, path, { locale: newLocale });
            return;
        }

        const target =
            newLocale === 'en'
                ? `https://simplify-data.com${path}`
                : `https://simplify-data.de${path}`;

        window.location.href = target;
    };



    return {
        t,
        tHtml,
        locale,
        changeLanguage,
        locales: ['de', 'en']
    };
} 